import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  questions: [],
  questionsRef: null,
  questionsLoaded: false
}

const getters = {
  questions (state) {
    return state.questions
  },
  questionsRef (state) {
    return state.questionsRef
  },
  questionsLoaded (state) {
    return state.questionsLoaded
  },
  questionByKey (state) {
    return (qKey) => {
      return state.questions.find(q => {
        return q.key === qKey
      })
    }
  },
  questionData (state) {
    return (qId) => {
      return state.questions.find(q => {
        return q.id === qId
      })
    }
  }
}

const mutations = {
  setQuestions (state, payload) {
    state.questions = payload
  },
  setQuestionsRef (state, payload) {
    state.questionsRef = payload
  },
  setQuestionsLoaded (state, payload) {
    state.questionsLoaded = payload
  }
}

const actions = {
  loadQuestions: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('questions')
    ref.on('value', (snapshot) => {
      const questions = []
      snapshot.forEach(q => {
        questions.push({...q.val(), key: q.key})
      })
      store.commit('setQuestionsRef', ref)
      store.commit('setQuestions', questions)
      store.commit('setQuestionsLoaded', true)
      resolve()
    })
  }),
  addQuestion: (store, payload) => new Promise((resolve, reject) => {
    let questionData = payload.body.toLowerCase() + ' '
    questionData += payload.rationale ? payload.rationale.toLowerCase() + ' ' : ''
    questionData += payload.type.toLowerCase() + ' '
    for (let t of payload.tags) {
      questionData += t.toLowerCase() + ' '
    }
    for (let a of payload.answers) {
      questionData += a.text.toLowerCase() + ' '
    }
    questionData += payload.id + ' '
    const newQuestion = {
      ...payload,
      tags: payload.tags ? [...payload.tags] : [],
      answers: [],
      data: questionData
    }
    for (let a of payload.answers) {
      newQuestion.answers.push({...a})
    }
    store.getters.questionsRef.push(newQuestion).then(q => {
      resolve(q)
    }).catch((err) => {
      reject(err)
    })
  }),
  updateQuestion: (store, payload) => new Promise((resolve, reject) => {
    let questionData = payload.body.toLowerCase() + ' '
    questionData += payload.rationale ? payload.rationale.toLowerCase() + ' ' : ''
    questionData += payload.type.toLowerCase() + ' '
    for (let t of payload.tags) {
      questionData += t.toLowerCase() + ' '
    }
    for (let a of payload.answers) {
      questionData += a.text.toLowerCase() + ' '
    }
    questionData += payload.id + ' '
    const newQuestion = {
      ...payload,
      tags: payload.tags ? [...payload.tags] : [],
      answers: [],
      data: questionData
    }
    for (let a of payload.answers) {
      newQuestion.answers.push({...a})
    }
    store.getters.questionsRef.child(newQuestion.key).set(newQuestion).then((q) => {
      resolve(q)
    }).catch((err) => {
      reject(err)
    })
  }),
  deleteQuestion: (store, payload) => new Promise((resolve, reject) => {
    const toDelete = {...payload}
    store.getters.questionsRef.child(toDelete.key).remove().then(() => {
      resolve()
    }).catch((err) => {
      reject(err)
    })
  }),
  resetQuestions (store) {
    if (store.getters.questionsRef) store.getters.questionsRef.off()
    store.commit('setQuestionsRef', null)
    store.commit('setQuestions', [])
    store.commit('setQuestionsLoaded', false)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/questions.js